exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".itemPos {\n  margin-top: 40px; }\n\n.errMsg {\n  margin-top: 20px; }\n\n.width-auto {\n  width: auto !important; }\n\n.unset-pad {\n  padding-right: unset !important; }\n\n@media (min-width: 767px) and (max-width: 1025px) {\n  .font-12 {\n    font-size: 12px; }\n  .font-15 {\n    font-size: 15px !important; } }\n\n.bagout-err-margin-20 {\n  margin-top: 20px !important; }\n\n.bagout-history-dt-picker-section .form-control {\n  height: 45px !important; }\n\n.bagout-history-dd-section .searchandselect .header {\n  height: 43px !important;\n  padding: 13px 15px !important;\n  z-index: 1; }\n\n.bagout-history-btn-section {\n  display: flex;\n  justify-content: end;\n  gap: 5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/branch_management/components/bagouts/bagouts.scss
// module id = 974
// module chunks = 1